export default function Footer() {
  return (
    <footer className="relative" style={{ backgroundColor: 'oklch(var(--secondary-100))' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <a href="#" className="flex items-center whitespace-nowrap">
              <img
                src="https://storage.readdy-site.link/project_files/a8eed8a9-7380-4e8e-9ad5-85d3476c739a/a0756213-e360-4558-93ae-fc7e63107e68_compressed_Design-sem-nome-3.webp"
                alt="The Future Wedding"
                className="h-8 md:h-10 w-auto"
              />
            </a>
            <p className="mt-4 text-sm leading-relaxed max-w-xs" style={{ color: 'oklch(var(--foreground-500))' }}>
              A primeira imersão para noivas que querem escolher com intenção.
              Ribeirão Preto, São Paulo.
            </p>
          </div>

          {/* Navigation Columns */}
          <div className="md:col-span-2">
            <h4 className="text-[10px] tracking-[0.2em] uppercase mb-4 font-semibold" style={{ color: 'oklch(var(--foreground-700))' }}>
              Navegação
            </h4>
            <ul className="space-y-3">
              <li><a href="#para-quem" className="text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>Para Quem</a></li>
              <li><a href="#manifesto" className="text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>Manifesto</a></li>
              <li><a href="#experiencia" className="text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>Experiência</a></li>
              <li><a href="#palestrantes" className="text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>Palestrantes</a></li>
              <li><a href="#informacoes" className="text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>Informações</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[10px] tracking-[0.2em] uppercase mb-4 font-semibold" style={{ color: 'oklch(var(--foreground-700))' }}>
              Contato
            </h4>
            <ul className="space-y-3">
              <li className="text-sm" style={{ color: 'oklch(var(--foreground-500))' }}>Ribeirão Preto, SP</li>
              <li className="text-sm" style={{ color: 'oklch(var(--foreground-500))' }}></li>
              <li className="text-sm" style={{ color: 'oklch(var(--foreground-500))' }}>(16) 98135-1663</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="flex items-center gap-3 mb-4">
              <div>
                <p className="text-sm font-semibold" style={{ color: 'oklch(var(--foreground-800))' }}>Íris Digital</p>
                <p className="text-xs" style={{ color: 'oklch(var(--foreground-500))' }}>Marketing e Audiovisual</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderTop: '1px solid oklch(var(--secondary-200) / 0.5)' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>
            &copy; {new Date().getFullYear()} The Future Wedding. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs transition-colors duration-300 whitespace-nowrap cursor-pointer" style={{ color: 'oklch(var(--foreground-400))' }}>
              Termos de Privacidade
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}